<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>充值管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
      </el-tabs>

      <el-row :gutter="20">
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.order_id" clearable @clear="getList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status + '&order_id=' + queryInfo.order_id + '&agencyName=' + queryInfo.agencyName">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed :key="Math.random()"> </el-table-column>

        <el-table-column type="index"></el-table-column>
        <el-table-column label="经销商名称" prop="agencyName"></el-table-column>

        <el-table-column align="center" label="凭证" width="160px" :show-overflow-tooltip="true" prop="pingzheng">
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="click">
              <el-image slot="reference" :src="scope.row.pingzheng" :alt="scope.row.pingzheng" style="max-height: 140px; max-width: 140px"></el-image>
              <el-image style="max-height: 500px; max-width: 500px" :src="scope.row.pingzheng"></el-image>
            </el-popover>
          </template>
        </el-table-column>

        <!-- <el-table-column label="昵称" prop="nickname"></el-table-column> -->
        <el-table-column label="充值金额" prop="money" align="center" width="80px"></el-table-column>
        <el-table-column label="订单号" prop="order_id"></el-table-column>
        <el-table-column label="充值时间" align="center" prop="create_at"></el-table-column>
        <el-table-column label="充值平台信息">
          <template slot-scope="scope">
            <div>平台账户类型：{{ scope.row.ptType }}</div>
            <div>账户名称：{{ scope.row.ptName }}</div>
            <div>平台账户：{{ scope.row.ptAccount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'">未审核</el-tag>
            <el-tag class="success" v-if="scope.row.status == '1'">已通过</el-tag>
            <el-tag class="danger" v-if="scope.row.status == '2'">已拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="beizhu"></el-table-column>
        <el-table-column label="拒绝理由" prop="seasion"></el-table-column>

        <el-table-column label="操作" width="180px" v-if="canLook == 1">
          <template slot-scope="scope" v-if="scope.row.status == '0'">
            <!-- 通过按钮 -->
            <el-tooltip effect="dark" content="通过" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-success" size="mini" @click="agreen(scope.row.id)"></el-button>
            </el-tooltip>
            <!-- 拒绝按钮 -->
            <el-tooltip effect="dark" content="拒绝" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="refuse(scope.row.id)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip effect="dark" content="修改金额" placement="top" :enterable="false">
              <el-button type="info" icon="el-icon-setting" size="mini" @click="addMoneyToRole(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="打回" :visible.sync="sendBackDialogVisible" width="50%" @close="sendBackDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="sendBackForm" :rules="sendBackRules" ref="sendBackRef" label-width="130px">
        <el-form-item label="打回理由" prop="seasion">
          <el-input maxlength="10" v-model="sendBackForm.seasion" placeholder="输入拒绝理由，最长10字"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendBackDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postRefuse">确定打回</el-button>
      </span>
    </el-dialog>

    <el-dialog title="凭证查看" :visible.sync="imgsVisible" width="60%" @close="imgDialogClosed">
      <div style="display: flex; justify-content: center">
        <el-image :src="tapImgScr" fit="scale-down" lazy style="margin: 10px auto">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button @click="imgsVisible = false" type="primary" style="width: 6vw">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改地址的对话框 -->
    <el-dialog title="修改充值金额" :visible.sync="addMoneyDialogVisible" width="50%" @close="addMoneyDialogVisibleClosed">
      <el-form :model="czForm" :rules="czFormRules" ref="czFormRef" label-width="100px">
        <el-form-item label="申请余额" prop="money">
          <el-input v-model="czForm.money" disabled></el-input>
        </el-form-item>

        <el-form-item label="增加/减少">
          <el-radio v-model="czForm.addtip" label="add">增加</el-radio>
          <el-radio v-model="czForm.addtip" label="reduce">减少</el-radio>
        </el-form-item>

        <el-form-item label="修改金额数" prop="changemoney">
          <el-input v-model="czForm.changemoney"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addMoneyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChangeMoney">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabIndex: 0,
      exportUrl: 'https://hsapi.sqmhsapi.sqmilk.com/rechargeExcel?mPhone=' + localStorage.getItem('phone'),
      canLook: 1,
      tapImgScr: '',
      imgsVisible: false,
      srcList: [],
      // 获取用户列表的参数对象
      queryInfo: {
        query: '',
        agencyName: '',
        order_id: '',
        time: null,
        status: -1,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10
      },
      list: [],//预览图片数组
      userlist: [],
      total: 0,
      sendBackid: 0,
      sendBackDialogVisible: false,
      sendBackForm: {
        seasion: '',
      },
      sendBackRules: {
        seasion: [
          { required: true, message: '请输入打回理由', trigger: 'blur' },
        ],
      },
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待审核', id: 0 },
        { value: '已通过', id: 1 },
        { value: '已拒绝', id: 2 },
      ],

      czForm: {
        id: null,
        money: null,
        changemoney: null,
        addtip: 'add',
      },
      addMoneyDialogVisible: false,
      czFormRules: {
        changemoney: [
          { required: true, message: '请输入要修改的金额', trigger: 'blur' }
        ]
      },
    }
  },

  created () {
    this.getList()
  },

  methods: {

    handleClick (tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      this.queryInfo.status = this.tabIndex - 1
      this.filterSelect();
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.sqmhsapi.sqmilk.com/rechargeExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.sqmhsapi.sqmilk.com/rechargeExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    timechange (e) {
      this.filterSelect();
    },

    //搜索
    search () {
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.userlist = []
      this.getList()
    },
    //账户冲正
    addMoneyToRole (row) {
      this.selectPhone = row.order_id;
      this.czForm.money = row.money;
      this.addMoneyDialogVisible = true
    },

    //修改经销商账户
    async sureChangeMoney () {
      this.$refs.czFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/user/changeChargeMoney', {
          money: this.czForm.changemoney,
          addtip: this.czForm.addtip,
          order_id: this.selectPhone
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.$message.success('设置成功！')
        this.getList();
        this.addMoneyDialogVisible = false;
      })
    },

    addMoneyDialogVisibleClosed () {
      this.$refs.czFormRef.resetFields()
    },

    imgDialogClosed () {
      this.srcList = []
      this.imgsVisible = false;
    },

    tapImage (pingzheng) {
      this.srcList = []
      console.log(pingzheng);
      this.srcList.push(pingzheng);
      // this.tapImgScr = pingzheng;
      this.imgsVisible = true;
    },

    async getList () {
      const { data: res } = await this.$http.get('admin/users/getAllUsersRecharge', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无充值信息！')
      }
      this.userlist = res.result.list
      this.total = res.result.count
      this.list = [];
      //获取每张图片的地址
      for (var i = 0; i < this.userlist.length; i++) {
        this.list.push(this.userlist[i].pingzheng)
      }
      //根据图片顺序（index）更改每张图片绑定的list的图片顺序
      for (var i = 0; i < this.userlist.length; i++) {
        var container = this.list;
        var frontArr = container.slice(0, i);
        var behindArr = container.slice(i, this.userlist.length);
        var list = behindArr.concat(frontArr)
        this.userlist[i].list = list;
      }
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      console.log(this.userlist)
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 监听添加用户对话框的关闭事件
    sendBackDialogClosed () {
      this.$refs.sendBackRef.resetFields()
      this.sendBackid = 0;
      this.sendBackDialogVisible = false
    },

    // 根据Id删除对应的用户信息
    async removeById (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该充值记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/users/deleteRecharge', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除失败！')
      }
      this.$message.success('删除成功！')
      this.getList()
    },

    // 通过
    async agreen (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将通过审核，充值到该经销商的充值账户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消')
      }
      // 在展示对话框之前，获取所有角色的列表
      const { data: res } = await this.$http.post('admin/users/updateUsersRecharge', {
        id: id,
        type: 1
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getList()
    },

    refuse (id) {
      this.sendBackid = id;
      this.sendBackDialogVisible = true
    },

    // 拒绝
    async postRefuse () {
      this.$refs.sendBackRef.validate(async valid => {
        if (!valid) return
        // 在展示对话框之前，获取所有角色的列表
        const { data: res } = await this.$http.post('admin/users/updateUsersRecharge', {
          id: this.sendBackid,
          seasion: this.sendBackForm.seasion,
          type: 2
        })
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.$message.success('操作成功！')
        this.sendBackid = 0;
        this.sendBackDialogVisible = false
        this.getList()
      });
    },
  }
}
</script>

<style lang="less" scoped>
</style>
